import React from "react";
import SAInputLabel from "../common/input/SAInputLabel";
import Constants from "../../services/Constants";
import {connect} from "react-redux";
import SADropdown from "../common/dropdown/SADropdown";
import * as types from "../../constants/ActionTypes";
import {getCustomerInformation} from "../../selectors/createAppointmentRequest";
import {FormattedMessage, injectIntl} from "react-intl";
import {Card} from "antd";
import {validateEmail} from "./utils/function_helper";
import FieldError from "../common/input/FieldError";

class CustomerInformation extends React.Component {

  onCustomerInformationChange = (value) => {
    this.props.dispatchSaveCustomerInformation({...value});
  };

  getErrorLogin = (login) => {
    if(!login){
      return {message: 'error.not.null'}
    }
    if(!validateEmail(login)) {
      return {message: 'error.email.invalid'};
    }
    return null
  };

  render() {
    const {intl: {formatMessage}, customerInformation, mandatoryList} = this.props;
    const languages = Constants.SUPPORTED_LANGUAGES_OPTIONS.map(language => ({
      value: language.value,
      display: formatMessage({id: language.label.id})
    }));
    languages.splice(0, 0, {value: null, display: ''});

    return (
      <Card title={<h3><FormattedMessage id="summary.customer"/></h3>} bordered={false} style={{width: '100%'}}>
        <div className="wrap">
          <div className="content">
            <div className="row">
              <div className="col-6 form-field">
                <SAInputLabel name="firstname" value={customerInformation.firstname} label={'customer.firstname'}
                              onChange={(e) => this.onCustomerInformationChange({firstname: e.target.value})}
                              error={(!mandatoryList || mandatoryList.includes('firstname')) && !customerInformation.firstname ? {message: 'error.not.null'} : null}
                />
              </div>
              <div className="col-6 form-field">
                <SAInputLabel name="lastname" value={customerInformation.lastname} label={'customer.lastname'}
                              onChange={(e) => this.onCustomerInformationChange({lastname: e.target.value})}
                              error={(!mandatoryList || mandatoryList.includes('lastname')) && !customerInformation.lastname ? {message: 'error.not.null'} : null}
                />
              </div>
              <div className="col-6 form-field">
                <SAInputLabel name="username" value={customerInformation.login}
                              label={'cui.home.login.username'}
                              onChange={(e) => this.onCustomerInformationChange({login: e.target.value})}
                              error={(!mandatoryList || mandatoryList.includes('username')) && this.getErrorLogin(customerInformation.login)}
                />
              </div>
              <div className="col-6 form-field">
                <SAInputLabel name="phone" value={customerInformation.phone} label={'placeholder.phone'}
                              onChange={(e) => this.onCustomerInformationChange({phone: e.target.value})}
                              error={(!mandatoryList || mandatoryList.includes('phone')) && !customerInformation.phone ? {message: 'error.not.null'} : null}
                />
              </div>
              <div className="col-6 form-field">
                <label htmlFor="language">
                  <FormattedMessage id="customer.journey.step.customerInformation.language"/>
                </label>
                <SADropdown
                  name={'language'}
                  value={customerInformation.language}
                  choices={languages}
                  onChange={(e) => this.onCustomerInformationChange({language: e.target.value})}
                />
                {!customerInformation.language &&
                  <FieldError error={{message: 'customer.journey.pleaseChoose'}}/>
                }
              </div>
            </div>
          </div>
        </div>
      </Card>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  dispatchSaveCustomerInformation: (params) => dispatch({type: types.SAVE_CUSTOMER_INFORMATION, params})
});

const mapStateToProps = state => ({
  customerInformation: getCustomerInformation(state)
});

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(CustomerInformation));
